import { TableContainer } from "@mui/material";
import { Table } from "antd";
import moment from "moment";
import React, { useState } from "react";
import ExportToExcel from "~/components/ExportToExcel";
import ExportToExcelMonitoring from "~/components/ExportToExcel/ExportToExcelMonitoring";

const MonitoringData = (data) => {
  // const [tableParams, setTableParams] = useState({
  //   pagination: {
  //     current: 1,
  //     pageSize: 25,
  //   },
  // });

  const columns = [
    {
      title: "Date",
      dataIndex: "Created_Dt",
      key: "Created_Dt",
      responsive: ["lg", "md", "xl", "sm"],
      render: (record) =>
        record === null ? "" : moment(record).format("DD/MM/YYYY"),
    },
    {
      title: "Location",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Loc_Name",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Loc_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Total Plantation area",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Area",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Area",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "GPS coordinates",
      children: [
        {
          title: "Latitude (N)",
          dataIndex: "Latitude",
          key: "Latitude",
          responsive: ["lg", "md", "xl", "sm"],
          render: (record) =>
            record === "null" ? "" : record,
        },
        {
          title: "Longitude (E )",
          dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Longitude",
          key: "Longitude",
          responsive: ["lg", "md", "xl", "sm"],
          render: (record) =>
            record === "null" ? "" : record,
        },
        {
          title: "Altitude (msl)",
          dataIndex: "Altitude_meter",
          key: "Altitude_meter",
          responsive: ["lg", "md", "xl", "sm"],
          render: (record) =>
            record === "null" ? "" : record,
        },
      ],
    },
    {
      title: "Location type",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Loc_Type",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Loc_Type",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Type of land",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Type_of_land",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.loc_mstr.Type_of_land",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plot name",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Name",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plot code",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Code",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Code",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plot area",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Area",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.Plot_Area",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Land use",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plot_mstr.Land_Use",
      key: "plantation_barcode_dtls.plantationDtl.plot_mstr.Land_Use",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Aspect",
      dataIndex: "plantation_barcode_dtls.plantationDtl.Aspect",
      key: "plantation_barcode_dtls.plantationDtl.Aspect",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Soil texture",
      dataIndex: "plantation_barcode_dtls.plantationDtl.Soil_Texture",
      key: "plantation_barcode_dtls.plantationDtl.Soil_Texture",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plant ID",
      dataIndex: "plantation_barcode_dtls.BarCode_Serial_No",
      key: "plantation_barcode_dtls.BarCode_Serial_No",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plant English name",
      dataIndex: "plantation_barcode_dtls.plantationDtl.plant_mstr.Plant_Eng_Name",
      key: "plantation_barcode_dtls.plantationDtl.plant_mstr.Plant_Eng_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Monitoring type",
      children: [
        {
          title: "Quantitative",
          children: [
            {
              title: "Plant height (m)",
              dataIndex: "PlantGrowth_Height",
              key: "PlantGrowth_Height",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Plant diameter (cm)",
              dataIndex: "PlantGrowth_Collar_Diameter",
              key: "PlantGrowth_Collar_Diameter",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Canopy cover (cm)",
              dataIndex: "Canopy_cover",
              key: "Canopy_cover",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Nitrogen (mg)",
              dataIndex: "Nitrogen",
              key: "Nitrogen",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Phosphate (mg)",
              dataIndex: "Phosphate",
              key: "Phosphate",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Potassium (mg)",
              dataIndex: "Potassium",
              key: "Potassium",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Soil pH",
              dataIndex: "Soil_PH",
              key: "Soil_PH",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Soil temperatrue (⁰C)",
              dataIndex: "Soil_Temperature",
              key: "Soil_Temperature",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Soil moisture content (%)",
              dataIndex: "Soil_Moisture",
              key: "Soil_Moisture",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Electricla conductivity",
              dataIndex: "Electrical_Conductivity",
              key: "Electrical_Conductivity",
              responsive: ["lg", "md", "xl", "sm"],
            },
          ],
        },
        {
          title: "Qualitative",
          children: [
            {
              title: "Leave bud formation",
              dataIndex: "Leaf_bud_formation",
              key: "Leaf_bud_formation",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Leaf fall",
              dataIndex: "Leaf_fall",
              key: "Leaf_fall",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Flower bud formation",
              dataIndex: "Flower_Bud_Formation",
              key: "Flower_Bud_Formation",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Open flower",
              dataIndex: "Open_Flower",
              key: "Open_Flower",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Fruit/Seed formation",
              dataIndex: "Fruit_Seed_Formation",
              key: "Fruit_Seed_Formation",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Fruit/seed ripe",
              dataIndex: "Fruit_Seed_Ripe",
              key: "Fruit_Seed_Ripe",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Fruit/seed fall",
              dataIndex: "Fruit_Seed_Fall",
              key: "Fruit_Seed_Fall",
              responsive: ["lg", "md", "xl", "sm"],
              render: (record) =>
                record === null ? "" : moment(record).format("DD/MM/YYYY"),
            },
            {
              title: "Plant growth flower count",
              dataIndex: "PlantGrowth_Flower_Count",
              key: "PlantGrowth_Flower_Count",
              responsive: ["lg", "md", "xl", "sm"],
            },
            {
              title: "Plant growth fruit count",
              dataIndex: "PlantGrowth_Fruit_Count",
              key: "PlantGrowth_Fruit_Count",
              responsive: ["lg", "md", "xl", "sm"],
            },
          ],
        },
      ],
    },
    {
      title: "Plant status",
      dataIndex: "Survivability",
      key: "Survivability",
      responsive: ["lg", "md", "xl", "sm"],
    },
  ];

  return (
    <>
      <ExportToExcelMonitoring data={data.reportData} columns={columns} fileName="Monitoring Data.csv" />
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table
          scroll={{
            x: 5000,
            y: 500,
          }}
          bordered
          columns={columns}
          dataSource={data.reportData}
          pagination={{
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      </TableContainer>
    </>
  );
};

export default MonitoringData;
